import Loader from '../../../misc/Loader';
import useCarrito from '../../../../services/intelafApiClient/handler/useCarrito';
import { styled } from '@material-ui/core';
import { useState, useEffect } from 'react';

const ButtonCounter = ({ producto, cantidad = 0 }) => {
    const { loader, handleAddProductoRecomendacion, handleUpdateProductoCarrito } = useCarrito(producto);
    const [ cantidadState, setCantidadState ] = useState(cantidad);

    useEffect(() => {
        setCantidadState(cantidad);
    }, [cantidad]);

    const handleAddProducto = async (e) => {
        e.stopPropagation();
        e.preventDefault();
        await handleAddProductoRecomendacion(1)
        .then((res) => {
            if(res) setCantidadState(cantidadState + 1);
        });
    };

    const handleDeleteProducto = async (e) => {
        e.stopPropagation();
        e.preventDefault();
        if(cantidadState <= 0) return;
        await handleUpdateProductoCarrito(producto.Codigo, cantidadState - 1)
        .then((res) => {
            if(res) setCantidadState(cantidadState - 1);
        });
    };

    const handleEvent = (e) => {
        e.stopPropagation();
        e.preventDefault();
    }
    
  return (
    <Content onClick={handleEvent}>
        {
            loader ? <Loader fontSize='25px' style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}/> :
            <>
                <Counter>
                    <span onClick={(e) => handleDeleteProducto(e)}>-</span>
                    <div>{cantidadState}</div>
                    <span onClick={(e) => handleAddProducto(e)}>+</span>
                </Counter>
            </> 
        }
    </Content>
  )
}

const Content = styled('div')({
    background: '#f8f8f8',
    borderRadius: '15px',
    height: '40px',
    minWidth: '140px',
    maxWidth: '150px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-evenly',
    '@media (max-width: 1200px)' : {
        minWidth: '100%',
        maxWidth: '100%',
    },
});

const Counter = styled('div')({
    height: '25px',
    width: '120px',
    background: '#ffffff',
    borderRadius: '10px',
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
    padding: '0px',
    margin: '0px',
    minWidth: '50%',
    '@media (max-width: 1200px)' : {
        minWidth: '75%',
    },
    '& span' : {
        margin: '10px',
        padding: '0px',
        fontSize: '18px',
        color: 'grey',
        cursor: 'pointer',
    },
    '& span:hover' : {
        color: 'red'
    }
})

export default ButtonCounter;